export { ProductionAreas } from './productionAreas.component';

